/** @jsxImportSource @emotion/react */
import React from 'react'
import times from 'lodash/times'
import Typography from '@signal/components/Typography'
import TypographySkeleton from '@signal/components/Skeleton/Typography'
import { LicenseInformationPropsType } from './types'
import {
  InstructionTypography,
  LicenseWrapper,
  RecordEntry,
  RecordWrapper,
  Wrapper
} from './styles'

const SKELETON_ENTRY_COUNT = 13

export const LicenseInformationSkeleton: React.FC<LicenseInformationPropsType> = () => {
  return (
    <Wrapper>
      <Typography variant="body1">
        License information for third party software
      </Typography>
      <Typography variant="body1">
        used by the PureCars Application Portal
      </Typography>
      <InstructionTypography>
        Click on any package or license type for more details.
      </InstructionTypography>
      <LicenseWrapper>
        {times(SKELETON_ENTRY_COUNT).map(val => (
          <RecordWrapper key={val}>
            <RecordEntry>
              {/* @ts-ignore */}
              <TypographySkeleton width={300} />
            </RecordEntry>
          </RecordWrapper>
        ))}
      </LicenseWrapper>
    </Wrapper>
  )
}

export default LicenseInformationSkeleton
